import { render, staticRenderFns } from "./payroll_template.vue?vue&type=template&id=772a00bc&scoped=true&"
import script from "./payroll_template.vue?vue&type=script&lang=js&"
export * from "./payroll_template.vue?vue&type=script&lang=js&"
import style0 from "./payroll_template.vue?vue&type=style&index=0&id=772a00bc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a00bc",
  null
  
)

export default component.exports